import { QrCodeIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Dialog from ".";
import { useEffect, useState } from "react";
import { IconBasicSubs, IconLoading, IconProSubs } from "../../assets/icons";
import CardSubscription from "../cards/CardSubscription";
import { SubInfoPage } from "../account/SubInfoPage";
// import Checkbox from "../commons/Checkbox";
// import { useTranslat/ion } from "react-i18next";
// import { ChevronDownIcon } from "@heroicons/react/24/solid";

const DialogSubscriptionPlan = ({ open, onClose }) => {
  // const [loading, setLoading] = useState(false);
  // const [errorText, setErrorText] = useState("");
  // const [isYearly, setIsYearly] = useState(true);

  return (
    <Dialog open={open} onClose={onClose} width="1150px" className="!ring-[0]">
      <div className="relative">
        <div className="w-[530px] h-[530px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-[#AFFFFE] rounded-full blur-[250px] z-[-1]" />
        {/* <div className="flex items-center justify-end w-full border-b border-[#D9D9D9] pb-1"> */}
        <div className="flex items-center justify-start w-full relative">
          <button
            className="bg-transparent hover:bg-transparent text-black absolute -top-2 -right-3 xl:top-0 xl:right-0"
            onClick={onClose}
          >
            <XMarkIcon className="w-[24px] h-[24px]" />
          </button>
        </div>

        <SubInfoPage
          className="!bg-transparent"
          classNameContent={"!gap-1"}
          isDialog
        />
      </div>
    </Dialog>
  );
};

export default DialogSubscriptionPlan;
